import {
    useContext,
    useEffect,
    useState
} from 'react';
import Head from 'next/head';

import { RequestNextApi } from '../../api/Request';
import { ProgressContext } from '../../components/Context/progressContext';
import MarketingNavigation from '../../navigation/marketing';
import { showArticleBlock } from '../../utils/static-pages/function';
import { PAGES_SLUG } from '../../utils/static-pages/model';
import { ShowNotification } from '../../utils/notification/snackbarUtils';
export default function FindCKA() {
    const [articleBlocks, setArticleBlocks] = useState();
    const { state: progressContext, update: updateProgress } = useContext(ProgressContext);

    useEffect(() => {
        const fetchPage = async () => {
            try {
                const res = await RequestNextApi.post('/pages',
                    {
                        slug: PAGES_SLUG.MARKETING_FIND_A_CKA,
                    }
                );
                if (res.data.success) {
                    setArticleBlocks(res.data.page.articleBlocks);
                } else {
                    ShowNotification.error('Fetch page failed');
                }
            } catch (error) {
                ShowNotification.error('Fetch page failed');
            }
        };

        const initPage = async () => {
            updateProgress({ isLoading: true });
            await fetchPage();
            updateProgress({ isLoading: false });
        };

        initPage();
    }, []);

    return (
        <>
            <Head>
                <title>Certified Kingdom Advisor® | Find an Advisor Near You</title>
                <meta name="description" content="Find Certified Kingdom Advisor®s near you for expert financial guidance rooted in faith. Locate a trusted Certified Kingdom Advisor® for your financial journey." />
            </Head>
            <MarketingNavigation>
                {articleBlocks && (
                    <div className='marketing-home--find-a-cka'>
                        {articleBlocks.map((item, index) => (
                            showArticleBlock(item, index)
                        ))}
                    </div>
                )}
            </MarketingNavigation>
        </>
    )
}

FindCKA.getLayout = page => <>{page}</>;
FindCKA.isPublic = true;
